import React from 'react';
import AppContainer from '../app-container';
import * as stageActions from '../../actions/stages';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';
import Select from '../../components/form/select';
import DataTable from '../../components/data-table/data-table';

class StagesPageContainer extends AppContainer {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            query: '',
            distance: null
        };
    }

    componentWillMount() {
        this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        if (fetchParams.distance) {
            this.props.actions.fetchStageResults(this.props.params.itemId, fetchParams.page, fetchParams.size, {
                query: fetchParams.query,
                distance: fetchParams.distance.value
            });
        }

    }

    onDistanceChange(value) {
        this.fetch({distance: value, page: 0});
    }

    handleQueryChange(event) {
        this.fetch({query: event.target.value, page: 0});
    }

    renderContent() {
        if (!this.state.distance) {
            return <div>{LocalizedStrings.selectDistance}</div>
        }
        const {stageResults} = this.props;
        if (!this.props.stageResults.items.length) {
            return <div>{LocalizedStrings.noResults}</div>
        } else {
            let config = {
                cols: []
            };
            const firstItem = this.props.stageResults.items[0];
            firstItem.titles.forEach((col, index) => {
                config.cols.push({
                    value: (item) => {
                        return item.row[index]
                    },
                    header: col
                })
            });
            if (this.props.stage.item.generate_diploma) {
                config.cols.push({
                    header: '',
                    value: (item) => {
                        return <a className="btn btn-main-color inline " target="_blank"
                                  href={`/api/participant-file/${item.id}`}>{LocalizedStrings.diploma}</a>
                    }
                })
            }
            return <DataTable config={config} loading={stageResults.loading} items={stageResults.items}
                              page={stageResults.page} total={stageResults.total} totalPages={stageResults.total_pages}
                              loadAction={this.fetch.bind(this)} responsive={false}
                              className="results-table"/>
        }
    }

    renderResults() {
        const stage = this.props.stage.item;
        if (stage.distances) {
            const distances = stage.distances.sort((a, b) => {
                if (a.order < b.order) {
                    return -1;
                }
                if (a.order > b.order) {
                    return 1;
                }
                return 0;
            }).map((distance) => {
                return {id: distance.code, name: distance.name}
            });
            return (
                <div>
                    <div className="filters">
                        <form>
                            <div className="inline-fields">
                                <div className="form-row">
                                    <div className="form-field">
                                        <div className="field-control">
                                            <Select clearable={false} options={distances}
                                                    noResultsText={LocalizedStrings.noDistances}
                                                    value={this.state.distance} placeholder={LocalizedStrings.distance}
                                                    onChange={this.onDistanceChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <div className="field-control">
                                            <input type="text" value={this.state.query}
                                                   onChange={this.handleQueryChange.bind(this)}
                                                   placeholder={LocalizedStrings.search}/>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </form>
                    </div>
                    {this.renderContent()}
                </div>

            )
        }
        return null;

    }

    render() {
        const {stage} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.stageResults)}>

                <div className="page-section">
                    <div className="container fluid">
                        <h1 className="title">
                            <span>{stage.item.name}
                            </span>
                        </h1>
                        <h3 className="title">
                            <span>{LocalizedStrings.stageResults}
                            </span>
                        </h3>
                        {stage.loading
                            ? <Loading/>
                            : this.renderResults()}

                    </div>
                </div>
            </DocumentTitle>
        )

    }
}

export default connect(function (state) {
    return {stage: state.stage.stage, stageResults: state.stage.stageResults};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...stageActions
        }, dispatch)
    };
})(StagesPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/stage-results-page-container.js